import { RouteRecordRawArgumented } from 'src/types/route'
import useI18n from 'src/hooks/i18n'
import { toInteger } from 'lodash'
import useRouteParser from 'src/hooks/routeParser'

const { t } = useI18n()
const { getPaginationCasts, getPaginationInject, toBoolean, toArrayOfInt } =
  useRouteParser()

const permission = 'order_bot_manage'

const module: RouteRecordRawArgumented = {
  path: 'phantom-orders',
  name: 'phantomOrders',
  component: () =>
    import(
      /* webpackChunkName: "phantom-orders" */ 'pages/order-bot/PhantomOrders.vue'
    ),
  meta: {
    breadcrumb: {
      name: t('breadcrumb.order_bot.phantom_orders'),
      icon: 'mdi-pill-multiple',
    },
    auth: { permission },
    inject: {
      query: {
        ...getPaginationInject(),
        sort: 'id',
        dir: 'desc',
        show_closed: false,
        year: new Date().getFullYear(),
      },
    },
    casts: {
      query: {
        show_closed: toBoolean,
        warehouse_id: toArrayOfInt,
        number: toArrayOfInt,
        year: toInteger,
        ...getPaginationCasts(),
      },
    },
  },
  children: [
    {
      path: ':id',
      name: 'phantomOrdersShow',
      component: () =>
        import(
          /* webpackChunkName: "phantom-orders-show" */ 'pages/order-bot/PhantomOrdersShow.vue'
        ),
      meta: {
        breadcrumb: {
          icon: 'mdi-land-rows-horizontal',
          name: t('breadcrumb.order_bot.phantom_orders_show'),
        },
        casts: {
          params: {
            id: toInteger,
          },
        },
      },
    },
    {
      path: 'upload',
      name: 'phantomOrdersUpload',
      component: () =>
        import(
          /* webpackChunkName: "phantom-orders-upload" */ 'pages/order-bot/PhantomOrdersUpload.vue'
        ),
      meta: {
        breadcrumb: {
          icon: 'mdi-upload',
          name: t('breadcrumb.order_bot.phantom_orders_upload'),
        },
      },
    },
  ],
}

export default module
